var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 47,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M44.353 10C51.89 10 58 16.181 58 23.806s-6.11 13.806-13.647 13.806c-3.379 0-6.47-1.243-8.853-3.3a13.5 13.5 0 0 1-8.852 3.3C19.11 37.612 13 31.43 13 23.806 13 16.18 19.11 10 26.648 10c3.377 0 6.469 1.241 8.852 3.298A13.5 13.5 0 0 1 44.353 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M44.353 10C51.89 10 58 16.181 58 23.806s-6.11 13.806-13.647 13.806c-3.379 0-6.47-1.243-8.853-3.3a13.84 13.84 0 0 0 4.795-10.506c0-4.208-1.86-7.976-4.795-10.508A13.5 13.5 0 0 1 44.353 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M35.5 13.298a13.84 13.84 0 0 1 4.795 10.508A13.84 13.84 0 0 1 35.5 34.313a13.84 13.84 0 0 1-4.795-10.507c0-4.208 1.86-7.976 4.795-10.508"
  })));
};
export default SvgMastercard;